<script setup lang="ts">
import { useScreenSize } from "@soft-db/ui";
import { icMonitorHeartOutline } from "../icons";
import { MapItemType } from "../map/use/use-marker-manager";
import NavButton from "./NavButton.vue";

defineProps<{
	sourceType: MapItemType;
	sourceId: string;
	disabled?: boolean;
	disabledReason?: string;
}>();

const { t } = useI18n();
const { mdOrLower } = useScreenSize();
</script>

<template>
	<NavButton
		:title="t('integrity-settings.integrity')"
		:icon="icMonitorHeartOutline"
		:to="{
			name: sourceType === 'station' ? 'integrity-stations-id' : 'integrity-sites-id',
			params: { id: sourceId },
		}"
		color="error"
		:size="mdOrLower ? 'lg' : 'sm'"
		:disabled="disabled"
		:disabledReason="disabledReason"
	/>
</template>
